import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import ApprovalsPanel from './ApprovalsPanel';
import NotificationsPanel from './NotificationsPanel';

function ApprovalsPage() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  // Rediriger vers l'accueil si l'utilisateur n'a pas les permissions
  if (!['superviseur', 'manager'].includes(user?.role)) {
    navigate('/');
    return null;
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f8f9fa' }}>
      {/* Barre de navigation */}
      <div style={{
        background: '#9cb85c',
        padding: '10px 20px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: '2px solid #000'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
          <h1 style={{ margin: 0, color: 'white', fontSize: '24px' }}>
            ✅ Approbations - 6W2H v2.0
          </h1>
          <div style={{ display: 'flex', gap: '10px' }}>
            <button
              onClick={() => navigate('/')}
              style={{
                background: 'rgba(255,255,255,0.2)',
                color: 'white',
                border: '1px solid rgba(255,255,255,0.3)',
                padding: '6px 12px',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              📝 Formulaires
            </button>
            {user?.role === 'manager' && (
              <button
                onClick={() => navigate('/dashboard')}
                style={{
                  background: 'rgba(255,255,255,0.2)',
                  color: 'white',
                  border: '1px solid rgba(255,255,255,0.3)',
                  padding: '6px 12px',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                📊 Dashboard
              </button>
            )}
          </div>
        </div>
        
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          <NotificationsPanel />
          <span style={{ color: 'white', fontSize: '14px' }}>
            👤 {user?.prenom} {user?.nom} ({user?.role})
          </span>
          <button 
            onClick={logout}
            style={{
              background: 'rgba(255,255,255,0.2)',
              color: 'white',
              border: '1px solid rgba(255,255,255,0.3)',
              padding: '8px 15px',
              borderRadius: '5px',
              cursor: 'pointer'
            }}
          >
            Déconnexion
          </button>
        </div>
      </div>

      {/* Contenu principal */}
      <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{ marginBottom: '20px' }}>
          <button
            onClick={() => navigate('/')}
            style={{
              background: '#6c757d',
              color: 'white',
              border: 'none',
              padding: '10px 20px',
              borderRadius: '5px',
              cursor: 'pointer',
              marginRight: '10px'
            }}
          >
            ← Retour au formulaire
          </button>
          <button
            onClick={() => navigate('/dashboard')}
            style={{
              background: '#9cb85c',
              color: 'white',
              border: 'none',
              padding: '10px 20px',
              borderRadius: '5px',
              cursor: 'pointer'
            }}
          >
            📊 Dashboard
          </button>
        </div>

        <ApprovalsPanel />

        {/* Informations pour les utilisateurs */}
        <div style={{
          marginTop: '30px',
          padding: '20px',
          background: 'white',
          border: '1px solid #dee2e6',
          borderRadius: '8px'
        }}>
          <h4 style={{ color: '#9cb85c', margin: '0 0 15px 0' }}>
            ℹ️ Guide des Approbations
          </h4>
          
          <div style={{ fontSize: '14px', lineHeight: '1.6' }}>
            <p><strong>Rôles et permissions :</strong></p>
            <ul>
              <li><strong>Opérateur :</strong> Peut créer et soumettre des formulaires pour approbation</li>
              <li><strong>Superviseur :</strong> Peut approuver les formulaires soumis par les opérateurs</li>
              <li><strong>Manager :</strong> Peut approuver tous les formulaires et accéder aux statistiques</li>
            </ul>

            <p><strong>Workflow d'approbation :</strong></p>
            <ol>
              <li>L'opérateur crée un formulaire et le passe en "En cours"</li>
              <li>Quand prêt, l'opérateur demande l'approbation ("En attente approbation")</li>
              <li>Le superviseur/manager reçoit une notification</li>
              <li>Après évaluation, le formulaire est "Validé" ou "Rejeté"</li>
              <li>Si rejeté, l'opérateur peut le corriger et le resoumettre</li>
            </ol>

            <p><strong>Critères d'approbation :</strong></p>
            <ul>
              <li>Complétude des informations</li>
              <li>Pertinence de l'analyse</li>
              <li>Justification des coûts estimés</li>
              <li>Cohérence des actions proposées</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ApprovalsPage;
